import * as actionTypes from '../actionTypes/yotpo';

export function getYotpoSiteRatings() {
    return { type: actionTypes.YOTPO_SITE_RATINGS_LOAD };
}
